// extracted by mini-css-extract-plugin
export default {"wrapper":"not_found_wrapper__idfuy","title":"not_found_title__WKl0F","text":"not_found_text__EQKQh"};